import React from 'react';
import { DatePicker, Space, Typography } from 'antd';
import dayjs, { Dayjs } from 'dayjs';
import moment, { Moment } from 'moment';
const { Text } = Typography;

interface Props {
    setFilters: (data: Object) => void;
}

const Filter = (props: Props) => {

    React.useEffect(() => {
        props.setFilters({
            // month: moment().format('MM'),
            // year: moment().format('YYYY')
        });
    }, [])

    const handleDateChange = (date: Dayjs) => {

        props.setFilters({
            month: date && date.format('MM') || null,
            year: date && date.format('YYYY') || null,
        });
    };


    return (
        <Space direction="vertical" size={12}>

            <div>

                <Text>Select Year-Month : </Text>
                <DatePicker
            
                    style={{
                        width: 180
                    }}
                    defaultValue={null}
                    format={'YYYY-MM'}
                    onChange={handleDateChange}
                    allowClear={true}
                    picker="month"
                    placeholder="Select Year-Month"
                />
            </div>
        </Space>
    )
}

export default Filter